export default["__VITE_ASSET__Y0orpU87__","__VITE_ASSET__C0Ve9h$C__"];